import { format, parse } from "date-fns";
import { useEffect } from "react";
import useDashboardDatePicker from "../../hooks/useDashboardDatePicker";
import useFetch from "../../hooks/useFetch";
import { getAddOnAnalytics } from "../../services/Analytics.service";
import DashboardCard, { rateOf } from "./DashboardCard";

// SMS and luggage for the range picked in "Filtro datën". Its own request, so these cards load
// without holding up the rest of the page; the amounts are already inside "Totali i shitjeve".
const AddOnAnalytics = () => {
  const { from, to } = useDashboardDatePicker();
  const { loading, response, handleFunc } = useFetch(getAddOnAnalytics, {
    initRequest: false,
    loading: true,
    resetResponseOnError: true
  });

  useEffect(() => {
    if (from && to) {
      void handleFunc({
        startDate: format(parse(from, "dd/MM/yyyy", new Date()), "MM-dd-yyyy"),
        endDate: format(parse(to, "dd/MM/yyyy", new Date()), "MM-dd-yyyy")
      });
    }
  }, [from, to]);

  return (
    <div className="mt-2.5 flex w-full lg:flex-row flex-col">
      <DashboardCard
        title="Shitjet SMS"
        delay={450}
        type="fade-in"
        className="lg:mr-2.5 lg:mb-0 mb-2.5"
        currentValue={response?.data.textMeMyTripSales?.currentValue || "0"}
        ratePercentage={rateOf(response?.data.textMeMyTripSales)}
        ratePercentageDesc="prej periudhës së kaluar"
        loading={loading}
      />
      <DashboardCard
        title="Shitjet e valixheve"
        delay={500}
        type="fade-in"
        currentValue={response?.data.luggageStorageSales?.currentValue || "0"}
        ratePercentage={rateOf(response?.data.luggageStorageSales)}
        ratePercentageDesc="prej periudhës së kaluar"
        loading={loading}
      />
    </div>
  );
};

export default AddOnAnalytics;
